export default "__VITE_ASSET__D5bK9fuF__"